<template>
  <ion-content>
    <div id="container" style="margin-left: 24px;margin-right: 24px;">
      <ion-row>
      <ion-col>
      </ion-col>
      <ion-col>
      </ion-col>
      <ion-col>
        <button 
          type="button" 
          @click="closeModal()" 
          style="margin-left: 67%;margin-top: 6px; border-radius: 10px;"
        >
  
          <ion-icon :icon="closeOutline"></ion-icon> 
        </button>
      </ion-col>
    </ion-row>
      <ion-title> Automatizaciones </ion-title>
       <br>
      <ion-form>
        <div class="card">
          <ion-row>
            <ion-col>
              <div style="padding-top: 25px;">
                <ion-label>Designa</ion-label>
              </div>
            </ion-col>
            <ion-col>
              <ion-input type="text" v-model="designa_dias" placeholder="Ingrese los dias" />
            </ion-col>
            <ion-col>
              <ion-toggle v-model="designa_on" title="El correo se enviaría cada dias marcado" style="margin-top: 35px;"/>
            </ion-col>
          </ion-row>
          <div class="card">
            <table class="table table-responsive-sm table-striped table-align-middle" style="display: inline-table !important;">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Url</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="designa in designas" :key="designa">
                  <td>{{designa?.user?.name}}</td>
                  <td>{{designa?.url}}</td>
                  <td>
                    <button 
                      :aria-label="designa.url" 
                      class="button-copy-download" 
                      style="max-width: 50px;" 
                      color="primary" 
                      @click="copyLink"
                    >
                    <ion-icon  
                      :icon="clipboardOutline" 
                      :ios="clipboardOutline" 
                      :md="clipboardOutline">
                    </ion-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card">
          <ion-row>
            <ion-col>
              <div style="padding-top: 25px;">
                <ion-label>Minuta</ion-label>
              </div>
            </ion-col>
            <ion-col>

              <ion-input type="text" v-model="minuta_dias" placeholder="Ingrese los dias" />
            </ion-col>
            <ion-col>
              <ion-toggle v-model="minuta_on" title="El correo se enviaría cada dias marcado" style="margin-top: 35px;"/>        
            </ion-col>
          </ion-row>
        </div>
        <div class="card">
          <ion-row>
            <ion-col>
              <div style="padding-top: 25px;">
                <ion-label>Reclamaciones</ion-label>
              </div>
            </ion-col>
            <ion-col>
             
              <ion-input type="text" v-model="reclamacion_dias" placeholder="Ingrese los dias" />
            </ion-col>
            <ion-col>
              <ion-toggle v-model="reclamacion_on" title="El correo se enviaría cada dias marcado" style="margin-top: 35px;"/>        
            </ion-col>
          </ion-row>
        </div>
        <ion-button color="dark" @click="post">
          Enviar
        </ion-button>
      </ion-form>
    </div>
  </ion-content>
</template>

<script>

import { defineComponent } from 'vue';
import { closeOutline, clipboardOutline } from 'ionicons/icons';
import { modalController, IonInput, IonToggle  } from '@ionic/vue';
import axios from 'axios'
import toast from '@/plugins/toast'
import ClipboardJS from 'clipboard'

export default defineComponent({
  name: 'AgregarColaborador',
  components : { IonInput, IonToggle },
  props: ['siniestro'],
  setup() {
    return { closeOutline, clipboardOutline }
  },
  data() {
    return {
      designa_dias: null,
      designa_on: true,
      minuta_dias: null,
      minuta_on: true,
      reclamacion_dias: null,
      reclamacion_on: true,
      designas: []
    }
  },
  created(){
    if (this.siniestro.minuta_automatizacion != null) {
      this.minuta_dias = this.siniestro.minuta_automatizacion.dias
      this.minuta_on = this.siniestro.minuta_automatizacion.on
    }else{
      this.minuta_dias = null
      this.minuta_on = false
    }

    if (this.siniestro.reclamacion_automatizacion != null) {
      this.reclamacion_dias = this.siniestro.reclamacion_automatizacion.dias
      this.reclamacion_on = this.siniestro.reclamacion_automatizacion.on
    }else{
      this.reclamacion_dias = null
      this.reclamacion_on = false
    }

    if (this.siniestro.designa_automatizacion != null) {
      this.designa_dias = this.siniestro.designa_automatizacion.dias
      this.designa_on = this.siniestro.designa_automatizacion.on
    }else{
      this.designa_dias = null
      this.designa_on = false
    }
    this.getDeginas()
  },
  methods:{
    async closeModal(data = null) {
      const modal = await modalController
      return modal.dismiss(data == null ? 'close-button' : data);
    },
    async post(){

      var loading = await toast.showLoading()

      await loading.present();

      axios.post('/api/automatizaciones',{
        designa_dias: this.designa_dias,
        designa_on: this.designa_on,
        minuta_dias: this.minuta_dias,
        minuta_on: this.minuta_on,
        reclamacion_dias: this.reclamacion_dias,
        reclamacion_on: this.reclamacion_on,
        siniestro_id: this.siniestro.id
      })
      .then(data =>{
        loading.dismiss()
        this.closeModal('reload')
        this.$toast.openToast("Registro de compania exitoso","success")
        console.log(data)
      }).catch(err =>{
        loading.dismiss()
        console.log(err)
      })
    },
    getDeginas(){
      axios.get('/api/siniestros/designas/'+this.siniestro.id)
      .then(res => {
        console.log(res.data.data)
        this.designas = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    copyLink(){
      const self = this
      const clipboard = new ClipboardJS('.button-copy-download',{
        text: function(trigger) {
          return trigger.getAttribute('aria-label');
        }
      });

      clipboard.on('success', function(e) {
        self.$toast.openToast("Link copiado con exito","success")
        console.info('Action:', e.action);
        console.info('Text:', e.text);
        console.info('Trigger:', e.trigger);

        e.clearSelection();
      });

      clipboard.on('error', function(e) {
        self.$toast.openToast("Ha ocurrido un error al copiar","success")
        console.error('Action:', e.action);
        console.error('Trigger:', e.trigger);
      });
    },
  }
});
</script>

<style scoped>

ion-label {
  font-weight: bold;
}

ion-input {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

ion-button {
  width: auto;
  --border-radius: 5px;
  height: 35px;
  text-transform: none;
}
ion-textarea {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

.button-copy-download{
  width: 150px;
  height: 35px;
  background: #3e55b8;
  border-radius: 5px;
  text-transform: none;
}

ion-select {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
  height: 50px;
}

.ion-sel-3-lbl{
  color: blue;
}
</style>
